import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const PrivateRouter = () => {
  const location = useLocation();
  const { auth } = useSelector((state) => state);

  return auth ? <Outlet /> : <Navigate to="/" state={{ from: location }} replace />;
};

export default PrivateRouter;
